import React from "react";
import FormField from "./FormField.component";

export default function FormGroup({ field, form, onChange, errors, handleDateRange, startDate, endDate }) {
  const { colLg = 4, colMd = 4, colSm = 6, col = 12, name, hideInEdit, hideInForm } = field;
  const title = typeof field.title === "function" ? field.title(form) : field.title;

  return (hideInEdit && form?.id) || hideInForm ? null : (
    <div className={`col-lg-${colLg} col-md-${colMd} col-sm-${colSm} col-${col} my-1`}>
      <label>{title}</label>
      <FormField {...field} title={title} value={form[name]} onChange={onChange} handleDateRange={handleDateRange} startDate={startDate} endDate={endDate} />
      <div className="text-danger small px-1 py-1">{errors?.[name]}</div>
    </div>
  );
}
